import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, inject } from "vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { WSSignalR } from "@/core/plugins/signalr";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignOut',
  setup(__props) {

const router = useRouter();
const store = useStore();
const wsSignalR = inject(TenantGlobalInjectionKeys.WS_SIGNAL_R);

onMounted(() => {
  wsSignalR?.disconnect();
  store.dispatch(Actions.LOGOUT).then(() => router.push({ name: "sign-in" }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})